import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {WIZARD_GROUP_TYPES} from "../WizardItem/wizardItemInterface";
import {addNewFlowGroup} from "../wizardFlowActions";

const WizardGroupsAsideGroup = (props) => {

  const {wizardActiveItem, featureGroup, wizardFlowActiveMode, addNewFlowGroup, nodeType, groupIndex} = props;

  const asideFeatureGroupClick = () => {
    console.log("asideFeatureGroupClick", );
    addNewFlowGroup(wizardActiveItem, featureGroup, nodeType)
  }

  return (
    // <li className={"wizard-sidebar__list-item" + (isActive ? " wizard-sidebar-list__item--active" : "")}
    <li className={"wizard-sidebar__list-item"
      + (nodeType === WIZARD_GROUP_TYPES.custom ? " wizard-group--custom" : "")
      + (nodeType === WIZARD_GROUP_TYPES.inputs ? " wizard-group--inputs" : "")
      + (nodeType === WIZARD_GROUP_TYPES.appointment ? " wizard-group--appointment" : "")
      + (nodeType === WIZARD_GROUP_TYPES.review ? " wizard-group--review" : "")
      + (nodeType === WIZARD_GROUP_TYPES.success ? " wizard-group--success" : "")
      + (nodeType === WIZARD_GROUP_TYPES.contact ? " wizard-group--contact" : "")}
        data-index={groupIndex}
        data-group={featureGroup.groupName || featureGroup.name}
        onClick={asideFeatureGroupClick}>
      {wizardFlowActiveMode === WIZARD_GROUP_TYPES.group || nodeType
        ? featureGroup.customDisplayName || featureGroup.groupName
        : featureGroup.name}
    </li>
  )
};

WizardGroupsAsideGroup.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired,
  featureGroup: PropTypes.object.isRequired,
  nodeType: PropTypes.string,
  groupIndex: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {wizardFlowActiveMode} = store.wizardState;
  return {
    wizardFlowActiveMode
  };
};

const mapDispatchToProps = {
  addNewFlowGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardGroupsAsideGroup)
